// Unwraps the admin-services bonus proxy `{ data, meta }` envelope. Returns
// undefined when the payload is missing/non-object so callers stay null-safe.
export function bonusAdminBody<T>(response: { data?: unknown }): T | undefined {
  const root = response?.data;
  if (root == null || typeof root !== "object") {
    return undefined;
  }
  const o = root as Record<string, unknown>;
  if ("data" in o && o.data !== undefined) {
    return o.data as T;
  }
  return root as T;
}

export type BonusAdminEnvelope<T> = {
  body: T | undefined;
  message?: string;
};

// Same unwrap, but also captures the localized `message` sibling the V2
// ApiResponse envelope emits, so mutation hooks can prefer BE toast copy.
export function bonusAdminEnvelope<T>(response: {
  data?: unknown;
}): BonusAdminEnvelope<T> {
  const root = response?.data;
  let message: string | undefined;
  if (root != null && typeof root === "object") {
    const raw = (root as Record<string, unknown>).message;
    if (typeof raw === "string" && raw.trim()) {
      message = raw;
    }
  }
  return { body: bonusAdminBody<T>(response), message };
}
